import type { ReactNode } from 'react';

type Props = {
    htmlFor?: string;
    label: ReactNode;
    children: ReactNode;
};

export const FieldRow = ({ htmlFor, label, children }: Props) => (
    <div className="mb-xl">
        <label
            htmlFor={htmlFor}
            className="text-base mb-l block font-bold text-primary-10"
        >
            {label}
        </label>
        {children}
    </div>
);
